<template>
  <div class="detail">
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
          <el-form-item label="活动名称">
            <el-input v-model="ruleForm.name" disabled />
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker
              v-model="ruleForm.activityTime"
              :disabled="true"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="活动说明">
            <el-input v-model="ruleForm.description" type="textarea" :rows="4" disabled />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" label-width="100px">
          <el-form-item label="消费维度">
            <el-radio-group v-model="configForm.consumptionType" disabled>
                 <el-radio label="1">电量</el-radio>
              <el-radio label="2">金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励梯度" style="margin-bottom:0">
            <el-radio-group v-model="configForm.level" disabled>
              <el-radio label="1">一级</el-radio>
              <el-radio label="2">二级</el-radio>
              <el-radio label="3">三级</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-card v-for="(items,indexs) in configForm.coupons" :key="indexs" class="level-config">
            <div slot="header">
              <span>{{ numberfilter(indexs+1) }}级配置</span>
            </div>
            <el-form-item :label="configForm.consumptionType=='1'?'充电电量':'消费金额'">
              <el-input v-model="items.amount" disabled><template
                slot="append"
              >{{ configForm.consumptionType=='1'?'度':'元' }}</template></el-input>
            </el-form-item>
            <template v-for="(row,index) in items.coupons">
              <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)">
                <div class="d-flex">
                  <el-select v-model="row.couponId" style="width: 200px;" disabled>
                    <el-option
                      v-for="item in allCoupon"
                      :key="item.couponId"
                      :label="item.couponName"
                      :value="item.couponId"
                    />
                  </el-select>
                  <el-input v-model="row.count" class="ml-20" style="width: 100px;" disabled />
                  <div class="ml-20">张</div>
                </div>
              </el-form-item>
            </template>
          </el-card>

          <el-form-item label="活动电站">
            <el-radio-group v-model="configForm.stationType" disabled>
              <el-radio v-for="(item, index) in activitystationType" :key="index" :label="item.id">{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm.stationType==='2'" class="border">
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.stationValue"
                :props="treeDefaultProps"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm.stationType==='3'" class="border">
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="configForm.stationValue"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" label-width="100px">
          <el-form-item label="可参与用户">
            <el-radio-group v-model="partakeForm.userType" disabled>
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.userValue"
                :props="treeDefaultProps"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.userValue"
                :props="treeDefaultProps"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户参与记录</span>
      </div>
      <STable
        ref="detailTableref"
        :url="detailUrl"
        :columns="detailColumns"
        :query="detailQuery"
        :selection="false"
        :toolbar="detailToolbar"
        label-width="110px"
      />
    </el-card>
  </div>
</template>

<script>
import {
  numberfilter
} from '@/utils/tool'
import { HOST } from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  props: {
    // 表单信息数据
    // formData: {
    //   type: Object,
    //   default() {
    //     return {

    //     }
    //   }
    // },
    // // 预留的id，通过id查询详情信息
    // id: {
    //   type: Number,
    //   default: 0
    // }
  },
  data() {
    return {
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      ruleForm: {
        name: '', // 活动名称
        activityTime: [], // 活动时间
        description: '' // 活动说明
      },
      // 所有的优惠券数据
      allCoupon: [{
        id: 1,
        label: '优惠券一'
      },
      {
        id: 2,
        label: '优惠券二'
      },
      {
        id: 3,
        label: '优惠券三'
      }
      ],
      // 活动电站
      activitystationType: [{
        label: '全部电站',
        id: '1'
      }, {
        label: '选择运营商',
        id: '2'
      }, {
        label: '选择电站',
        id: '3'
      }],
      operatorTreeData: [], // 运营商树的全部数据
      stationTreeData: [], // 电站树的全部数据
      configForm: {
        consumptionType: '1', // 消费维度
        level: '1', // 奖励梯度
        coupons: [{
          amount: '', // 消费金额(充电电量) 表示达到多少
          coupons: [{
            couponId: '', // 选择的优惠券
            count: '' // 数量
          }]
        }],
        stationType: 1, // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: [] // 选择电站时的树数据
      },
      // 可参与用户字段的单选数据
      userTypeItem: [{
        label: '全部用户',
        id: '1'
      }, {
        label: '选择企业',
        id: '2'
      }, {
        label: '选择标签',
        id: '3'
      }],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        userType: 1, // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      detailUrl: '/activity/pageParticipation',
      detailColumns: [{
        label: '所属企业',
        prop: 'orgName'
      },
      {
        label: '用户账号',
        prop: 'loginName'
      },
      {
        label: '用户姓名',
        prop: 'userName'
      },
      {
        label: '手机号',
        prop: 'mobile'
      },
      {
        label: '累计消费金额/充电度数',
        prop: 'amount',
        template: (index, reocrd) => {
          if (this.configForm.consumptionType == '1') {
            return this.getFloat(reocrd.amount)+'度'
          } else {
            return this.getFixed2(reocrd.amount)+'元'
          }
        }
      },
      {
        label: '已达到奖励梯度',
        prop: 'level',
        template: function(index, record) {
          if (record.level === '1') {
            return '一级'
          } else if (record.level === '2') {
            return '二级'
          } else if (record.level === '3') {
            return '三级'
          }
           else if (record.level === '4') {
            return '四级'
          } else if (record.level === '5') {
            return '五级'
          } else if (record.level === '6') {
            return '六级'
          } else if (record.level === '7') {
            return '七级'
          } else if (record.level === '8') {
            return '八级'
          } else if (record.level === '9') {
            return '九级'
          }
           else if (record.level === '10') {
            return '十级'
          }
        }
      }
      ],
      detailQuery: [{
        label: '所属企业',
        prop: 'orgName',
        placeholder: '请输入企业名称'
        // type: 'select3',
        // data: [],
        // remoteMethod: (val) => {
        //   this.loadMechanism(val)
        // }
      }, {
        label: '用户账号',
        prop: 'loginName',
        placeholder: '请输入用户账号'
      }, {
        label: '手机号',
        prop: 'mobile',
        placeholder: '请输入手机号'
      },
      {
        label: '已达到奖励梯度',
        prop: 'level',
        placeholder: '请选择奖励梯度',
        type: 'select',
        data: [{
          label: '一级',
          value: '1'
        }, {
          label: '二级',
          value: '2'
        }, {
          label: '三级',
          value: '3'
        }]
      }
      ],
      detailToolbar: [{
        label: '导出',
        icon: 'el-icon-download',
        type: 'primary',
        handle: (index, record) => {
          const url = HOST + '/activity/exportParticipation?activityId=' + this.id
          const data = this.$refs.detailTableref.getQueryData()
          $.fileDownload(url, {
            httpMethod: 'GET',
            data: {
              token: window.localStorage.getItem('token'),
              ...data
            },
            failCallback: (html, url) => {
              this.$notify({
                title: '失败',
                message: '导出用户参与记录失败',
                type: 'error'
              })
            }
          })
        }
      }]
    }
  },
  beforeMount() {
        this.id=this.$route.query.id
    this.detailUrl = '/activity/pageParticipation?activityId=' + this.id
  },
  mounted() {
      this.formData=JSON.parse(decodeURIComponent(this.$route.query.infoForm))
    // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部运营商方法
    this.getOperatorTree()
    // 查询全部电站方法
    this.getStationTree()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()
    // 接收数据后回显赋值
    this.$nextTick(() => {
      console.log('接收到的数据', this.formData)
      this.ruleForm = JSON.parse(JSON.stringify(this.formData.ruleForm))
      this.ruleForm.activityTime = [this.ruleForm.start, this.ruleForm.end]

      this.configForm = JSON.parse(JSON.stringify(this.formData.configForm))
      // this.detailColumns[4].label = this.configForm.consumptionType === '1' ? '充电度数' : '累计消费金额'
      if (this.configForm.stationType === 2) {
        this.configForm.operator = this.configForm.stationValue.split(',')
        this.configForm.station = []
      } else if (this.configForm.stationType === 3) {
        this.configForm.station = this.configForm.stationValue.split(',')
        this.configForm.operator = []
      }

      this.partakeForm = JSON.parse(JSON.stringify(this.formData.partakeForm))
      if (this.partakeForm.userType === 2) {
        this.partakeForm.mechanism = this.partakeForm.userValue.split(',')
        this.partakeForm.tag = []
      } else if (this.partakeForm.userType === 3) {
        this.partakeForm.mechanism = []
        this.partakeForm.tag = this.partakeForm.userValue.split(',')
      }
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载企业数据
    loadMechanism(val) {
      const data = {
        name: val,
        pageNo: 1,
        pageSize: 100
      }
      this.$store.dispatch('form/handle', {
        url: '/org/page',
        data: data,
        callback: resp => {
          this.detailQuery[0].data = resp.list
        }
      })
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部运营商树的数据
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.operatorTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: resp => {
          this.stationTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = treeDisabled(resp, true)
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType:'0' },
        callback: resp => {
          this.tagTreeData = treeDisabled(resp, true)
        }
      })
    },
    cancel() {
      // this.$emit('backHome')
           this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex {
    display: flex;
  }

  .currentStock {
    height: 20px;
    align-items: center;
  }

  .ml-20 {
    margin-left: 20px;
  }

  .icon-jia {
    font-size: 22px;
    align-items: center;
    display: flex;
  }

  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }

  .detail {
    /deep/.el-input__inner {
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }

    /deep/.el-textarea__inner {
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }

    /deep/.el-range-input {
      border-color: #DCDFE6 !important;
      color: #606266 !important;
      cursor: pointer !important;
    }

    /deep/.el-range-separator {
      color: #606266 !important;
    }

    /deep/.el-range__icon {
      color: #606266 !important;
    }
  }

  /deep/ .el-card.level-config {
    margin: 10px 0;

    .el-card__header {
      font-size: 16px;
      padding: 10px 15px;
    }

    .el-card__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/cumulativeDetail.vue